<script lang="ts">
    export let data: Record<string, any>
</script>

<div class="block-preview">
    <div class="fake-toolbar">
        <span class="fake-btn bold">B</span>
        <span class="fake-btn italic">I</span>
        <span class="fake-btn underline">U</span>
        <span class="fake-sep" />
        <span class="fake-btn">•</span>
        <span class="fake-btn">1.</span>
    </div>
    <div class="fake-body">Sua resposta (com formatação)</div>
</div>

<style>
    .block-preview {
        width: 100%;
        max-width: 560px;
        border: 1px solid #ced4da;
        border-radius: 6px;
        overflow: hidden;
    }
    .fake-toolbar {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 6px 8px;
        background: #f1f3f5;
        border-bottom: 1px solid #ced4da;
    }
    .fake-btn {
        font-size: 0.78rem;
        color: #868e96;
        width: 20px;
        text-align: center;
    }
    .fake-btn.bold {
        font-weight: 700;
    }
    .fake-btn.italic {
        font-style: italic;
    }
    .fake-btn.underline {
        text-decoration: underline;
    }
    .fake-sep {
        width: 1px;
        height: 14px;
        background: #ced4da;
        margin: 0 2px;
    }
    .fake-body {
        padding: 10px;
        font-size: 0.9rem;
        color: #adb5bd;
        min-height: 44px;
    }
</style>
